import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Typography,
    Card, // <--- Add this right here
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./ViewAdmin.css";
import EditAdmin from "./EditAdmin"; // import the modal component

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const ViewAdmin = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [adminToDelete, setAdminToDelete] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [editOpen, setEditOpen] = useState(false); // controls modal open/close
    const [selectedAdmin, setSelectedAdmin] = useState(null); // stores admin to edit

    useEffect(() => {
        fetchAdmins();
    }, []);

    const fetchAdmins = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("accessToken");

            // Using your dual-fetch logic pattern if applicable, 
            // or a single fetch filtered by your backend
            const response = await axios.get(
                `${API_URL}/api/get_admins/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",   // ✅ REQUIRED (your backend checks this)
                    },
                }
            );
            setRows(response.data);

        } catch (error) {
            console.error("Fetch error:", error);
            toast.error("Failed to fetch admins");


        } finally {
            setLoading(false);
        }
    };
    const handleEditClick = (admin) => {
        setSelectedAdmin(admin);  // set which admin to edit
        setEditOpen(true);        // open the modal
    };


    const handleEditSave = (updatedAdmin) => {
        // Update the table locally
        setRows((prevRows) =>
            prevRows.map((row) => (row.id === updatedAdmin.id ? updatedAdmin : row))
        );
        // toast.success("Admin updated successfully!");
    };
    const handleDeleteClick = (admin) => {
        setAdminToDelete(admin);
        setDeleteOpen(true);
    };

    const handleConfirmDelete = async () => {
        try {
            const token = localStorage.getItem("accessToken");
            await axios.delete(
                `${API_URL}/api/delete_admin/${adminToDelete.id}/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json", // ✅ good practice
                    },
                }
            );
            toast.success("Admin Deleted Successfully");
            fetchAdmins();
            setDeleteOpen(false);
        } catch (error) {
            toast.error("Delete failed");
        }
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Box className="view-admin-container">


            {/* The Background Card with Gradient */}
            
                <TableContainer component={Paper} className="admin-table-wrapper">
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell className="table-header">Sr No</TableCell>
                                <TableCell className="table-header">First Name</TableCell>
                                <TableCell className="table-header">Last Name</TableCell>
                                <TableCell className="table-header">Email</TableCell>
                                <TableCell className="table-header">Phone Number</TableCell>
                                <TableCell className="table-header" align="center">Actions</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {rows
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => (
                                    <TableRow key={row.id} hover className="admin-table-row">
                                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                        <TableCell>{row.first_name}</TableCell>
                                        <TableCell>{row.last_name}</TableCell>
                                        <TableCell>{row.email}</TableCell>
                                        <TableCell>{row.phone_no}</TableCell>
                                        <TableCell align="center">
                                            <IconButton color="primary" onClick={() => handleEditClick(row)}>
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton color="error" onClick={() => handleDeleteClick(row)}>
                                                <DeleteIcon />
                                            </IconButton>


                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <EditAdmin
                        open={editOpen}
                        onClose={() => setEditOpen(false)}
                        admin={selectedAdmin}
                        onSave={handleEditSave}
                    />

                    {/* Pagination inside the inner paper for a clean look */}
                    {!loading && rows.length > 0 && (
                        <div className="pagination-bar">
                            <div className="rows-select">
                                Rows per page:
                                <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                </select>
                            </div>
                            <div className="page-info">
                                {page * rowsPerPage + 1}-{Math.min((page + 1) * rowsPerPage, rows.length)} of {rows.length}
                            </div>
                            <div className="page-arrows">
                                <button disabled={page === 0} onClick={() => setPage(page - 1)}>‹</button>
                                <button disabled={(page + 1) * rowsPerPage >= rows.length} onClick={() => setPage(page + 1)}>›</button>
                            </div>
                        </div>
                    )}
                </TableContainer>
            

            {/* Dialogs and Toast stay the same */}
            <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
                <DialogTitle>Delete Admin</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete{" "}
                        <strong>{adminToDelete?.first_name} {adminToDelete?.last_name}</strong>?
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setDeleteOpen(false)}>Cancel</Button>

                    <Button
                        onClick={handleConfirmDelete}
                        color="error"
                        variant="contained"
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
            <ToastContainer position="top-right" autoClose={3000} theme="light" />
        </Box>
    );
};

export default ViewAdmin;